import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './SignedDocumentSection.scss';
import HrbTranslate from 'components/language/HrbTranslate';
import DateTime from 'components/library/common/DateTime';
import ViewDownloadDocument from 'components/library/documents/ViewDownloadDocument';

const SignedDocumentSection = (props) => {
    const { elementId, title, uploaded, ticketId, documentType } = props;
    const [errorList, setErrorList] = useState([]);
    const handleViewDownloadFail = (docType) => {
        if (!errorList.includes(docType)) {
            setErrorList([...errorList, docType])
        }
    }

    // State Variables
    return (
        <div className='signed-document-section center' id={elementId}>
            <div className='signed-document-timestamp-section'>
                <p className='p1'>
                    <HrbTranslate text={title} />
                </p>
                <p className='p2'>
                    <DateTime boldValue={true} value={uploaded} dateAndTime/>
                </p>
            </div>
            <ViewDownloadDocument ticketId={ticketId} documentType={documentType}
                onViewDownloadFail={handleViewDownloadFail}/>
        </div>
    );
}

SignedDocumentSection.whyDidYouRender = false;

SignedDocumentSection.propTypes = {
    elementId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    uploaded: PropTypes.string.isRequired,
    ticketId: PropTypes.number.isRequired,
    documentType: PropTypes.string.isRequired
}

export default SignedDocumentSection